import { isWithinInterval } from "date-fns";

import UserLocationDatePeriod from "../enums/UserLocationDatePeriod";

import getDateRangeForSelectedDatePeriod from "./getDateRangeForSelectedDatePeriod";

// A granularity switch keeps today in view whenever the old period contains it. Otherwise the
// pre-existing behavior stands: a narrower period re-anchors to the start of the old one, a wider
// period keeps the anchor. We deliberately do NOT scan events to pick the "latest" day with data,
// because the old window's events may not be loaded yet.
const resolveDateForDatePeriodChange = (
  oldPeriod: UserLocationDatePeriod,
  newPeriod: UserLocationDatePeriod,
  anchor: Date | undefined,
  today: Date
): Date | undefined => {
  if (anchor === undefined) {
    return anchor;
  }

  const viewedRange = getDateRangeForSelectedDatePeriod(oldPeriod, anchor);
  if (isWithinInterval(today, { end: viewedRange.endDate, start: viewedRange.startDate })) {
    return getDateRangeForSelectedDatePeriod(newPeriod, today).startDate;
  }

  return newPeriod < oldPeriod ? viewedRange.startDate : anchor;
};

export default resolveDateForDatePeriodChange;
